export default __webpack_public_path__ + "static/media/05_o_5.8117ea18.jpg";